export default __webpack_public_path__ + "static/media/background.5273e2a1.webp";